import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import Grid from '@mui/material/Grid'
import LabeledItem from './LabeledItem'
import { selectAddress } from '../../../../data/address/addressSelectors'
import T from '../../../../T'

const AddressDetails = ({
  address,
  sx,
  spacing = 1,
  line1Label = T.ADDRESS,
  addressNameLabel = T.ADDRESS_NAME,
  showAddressName = false,
}) => {
  const { addressName, line1, unitNumber, city, state, zipCode } = selectAddress(address)
  const line1Str = `${[line1, unitNumber].filter(Boolean).join(', ')}`
  return (
    <Box sx={sx}>
      <Grid container sx={{ width: '100%' }} spacing={spacing}>
        {showAddressName && (
          <Grid size={12}>
            <LabeledItem primary={addressNameLabel} secondary={addressName || '-'} />
          </Grid>
        )}
        <Grid size={12}>
          <LabeledItem secondaryTypographyProps={{ variant: 'h6', fontWeight: 500 }} primary={line1Label} secondary={line1Str || '-'} />
        </Grid>
        <Grid container spacing={2} wrap="nowrap">
          <Grid>
            <LabeledItem primary="City" secondary={city || '-'} />
          </Grid>
          <Grid>
            <LabeledItem primary="State" secondary={state || '-'} />
          </Grid>
          <Grid>
            <LabeledItem primary="Zip code" secondary={zipCode || '-'} />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

AddressDetails.propTypes = {
  address: PropTypes.object.isRequired,
  sx: PropTypes.object,
  line1Label: PropTypes.string,
  addressNameLabel: PropTypes.string,
  showAddressName: PropTypes.bool,
  spacing: PropTypes.number,
}

export default AddressDetails
